import { useSearchParams } from 'next/navigation'

/**
 * A little wrapper around useSearchParams to return a path with search params.
 *
 * @param url - The base URL to append the search params to.
 * @param paramsToDelete - An array of search params to delete from the URL.
 * @returns A string with the base URL and the search params.
 */
export const usePathWithParams = (
  url: string,
  paramsToDelete: string[] = []
): string => {
  const searchParams = useSearchParams()
  const resultingParams = new URLSearchParams(searchParams)

  paramsToDelete.forEach((param) => {
    resultingParams.delete(param)
  })

  const params = resultingParams.toString()
  return params ? `${url}?${params}` : url
}
